import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminListViewModel, AdminListItem } from './user-account-list.vm';
import { Subject } from 'rxjs';
import { AlertService, ErrorHandlingService } from 'core-lib';
import { StateService } from '../services/state.service';
import { Router } from '@angular/router';
import { ListComponentBase } from 'core-lib';

import * as _ from 'lodash';
import { UserAccountService, AdminListModel, AdminListItemModel } from '../services/user-account.service';
import { PermitDetailsModel, PermitService } from '../services/permit.service';
import { environment } from '../../environments/environment';
import { YesCancelModalComponent } from '../modals/yes-cancel-modal/yes-cancel-modal.component';

@Component({
  selector: 'cli-user-account-list',
  templateUrl: './user-account-list.component.html',
  styleUrls: ['./user-account-list.component.scss']
})

export class UserAccountListComponent extends ListComponentBase implements OnInit {

  public vm = new AdminListViewModel();
  public filterChangeObservable = new Subject<string>();
  public maxAccounts: number = 30;

  @ViewChild('sendInstallationModal')
  public confirmModal: YesCancelModalComponent;

  constructor(private permitSvc: PermitService,
    private userAccountSvc: UserAccountService,
    private alertSvc: AlertService,
    private errorHandler: ErrorHandlingService,
    private router: Router,
    private stateSvc: StateService) {

    super();
    if (this.stateSvc.AdminListVm == null) {

      this.vm.filter.orderBy = 'Status';
      this.vm.filter.isDesc = true;
      this.vm.filter.skip = 0;
      this.vm.filter.take = 20;

      this.stateSvc.AdminListVm = this.vm;

    }

    this.vm = stateSvc.AdminListVm;
    this.vm.isOpening = true;

    this.loadList();
  }



  ngOnInit() {
    this.wireUpSearchTextFilter();
  }

  loadList(): Promise<void> {
    this.vm.isLoading = true;

    return this.permitSvc.getDetails().toPromise().then((permitdata: PermitDetailsModel) => {

      this.userAccountSvc.getList(this.vm.filter, permitdata.permitDetails.permitNo).toPromise().then((data: AdminListModel) => {


        this.mapModel(this.vm, data, permitdata);

        this.vm.isLoading = false;
        this.vm.isOpening = false;
      },
        (e) => {
          //this.errorHandlingSvc.processHttpError(e);
          this.vm.isLoading = false;
          this.vm.isOpening = false;
        });

    }, (e) => {
      this.errorHandler.processHttpError(e);
      this.vm.isLoading = false;
      this.vm.isOpening = false;
    });
  }

  mapModel(model: AdminListViewModel, data: AdminListModel, permitdata: PermitDetailsModel) {
    model.items = [];
    model.totalCount = data.totalCount;

    this.vm.permitNo = permitdata.permitDetails.permitNo;
    this.vm.businessName = permitdata.permitDetails.clientName;

    _.each(data.items, (i: AdminListItemModel) => {

      let m = new AdminListItem();
      m.userId = i.userId;
      m.userName = i.userName;
      m.fullName = i.fullName;
      m.email = i.email;
      m.status = i.status;

      model.items.push(m);

    });
  }

  public edit(adminId: string) {
    this.router.navigate([`app/user-accounts/${adminId}`]);
  }

  public sendInstallation(adminId: string) {
   
    this.confirmModal.message = 'The Hydrotrak App installation links will be sent to this account via SMS and email (if configured). <br/><br/>  Would you like to continue?';
    this.confirmModal.openModal().toPromise().then((result: string) => {

      if (result === 'Yes') {

        this.vm.isLoading = true;

        this.userAccountSvc.sendInstallation(this.vm.permitNo, adminId).toPromise().then(() => {
          this.alertSvc.success(environment.TOASTR_HEADER, `The Hydrotrak app installation links have been successfully sent`, 6000);
        }).finally(() => { this.vm.isLoading = false; });
      }

    });

    // this.userAccountSvc.sendSMS(this.vm.permitNo, adminId).subscribe(rs => {
    //   this.alertSvc.success(environment.TOASTR_HEADER, `The SMS was successfully sent `, 6000);
    // });
  }

  public addNew() {
    if (this.vm.items.length >= this.maxAccounts) {
      this.alertSvc.error(environment.TOASTR_HEADER, `Exceeded the maximum operator accounts (Maximum: ${this.maxAccounts} accounts)`, 6000);
      return;
    }

    this.router.navigate(['app/user-accounts/new']);
  }

}
